import { useState, useEffect, FC, HTMLAttributes } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

export const STATUS = 'STATUS' as const
export const PROGRESS_BAR = 'PROGRESS_BAR' as const

interface CountdownTimerProps extends HTMLAttributes<HTMLDivElement> {
  creationDate: Date
  type: typeof STATUS | typeof PROGRESS_BAR
}

const ONE_DAY = 24 * 60 * 60 * 1000
const ONE_HOUR = 60 * 60 * 1000
const ONE_MINUTE = 60 * 1000
const ONE_SECOND = 1000

const formatTime = (value: number): string => {
  return value < 10 ? `0${value}` : `${value}`
}

export const CountdownTimer: FC<CountdownTimerProps> = ({ creationDate, type = PROGRESS_BAR, className = '' }) => {
  const [timeLeft, setTimeLeft] = useState<number>(ONE_DAY)
  useEffect(() => {
    const now = new Date()
    const timePassed = now.getTime() - creationDate.getTime()
    const initialTimeLeft = Math.max(0, ONE_DAY - timePassed)
    setTimeLeft(initialTimeLeft)

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1000) {
          clearInterval(intervalId)
          return 0
        }
        return prevTime - 1000
      })
    }, 1000)

    return () => {
      clearInterval(intervalId) // очищаем таймер при размонтировании компонента
    }
  }, [creationDate])

  const hours = formatTime(Math.floor(timeLeft / ONE_HOUR))
  const minutes = formatTime(Math.floor((timeLeft % ONE_HOUR) / ONE_MINUTE))
  const seconds = formatTime(Math.floor((timeLeft % ONE_MINUTE) / ONE_SECOND))

  if (timeLeft <= 0) {
    return null
  }

  return (
    <div className={cn(styles.wrapper, { [styles.statusType]: type === STATUS }, className)}>
      {hours}:{minutes}:{seconds}
    </div>
  )
}
